<template>
  <div class="page-layout">
    <NavBar />
    <div class="page-view">
      <router-view />
    </div>
    <FooterBar />
  </div>
</template>
<script setup>
import NavBar from "./NavBar.vue"
import FooterBar from "./FooterBar.vue"
</script>
<style lang="scss">
.page-view {
  flex: 1;
  background: #46638D;
  position: relative
}
</style>
